import { Stack, useTheme } from "@mui/material";
import { mdHeight, SubNavAppBar, xsHeight } from "components/AppBar";
import { TAB_LINKS_HEIGHT } from "components/TabLinks";
import { WasteDateRangePicker } from "components/WasteDateRangePicker";
import { useState } from "react";

export function InvoiceAuditDateFilter({
  startDate,
  endDate,
  onAccept,
}: {
  startDate?: string;
  endDate?: string;
  onAccept: (next: { startDate?: string; endDate?: string }) => void;
}) {
  const theme = useTheme();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const handleAccept = (next: { startDate?: string; endDate?: string }) => {
    if (Boolean(next.startDate) !== Boolean(next.endDate)) {
      setErrorMessage("Select both a start date and an end date.");
      return;
    }
    setErrorMessage(null);
    onAccept(next);
  };
  return (
    <SubNavAppBar
      sx={{
        py: 2,
        px: 3,
        borderBottom: "1px solid",
        borderColor: "divider",
        top: {
          xs: `calc(${theme.spacing(xsHeight)} + ${TAB_LINKS_HEIGHT}px)`,
          md: `calc(${theme.spacing(mdHeight)} + ${TAB_LINKS_HEIGHT}px)`,
        },
      }}
    >
      <Stack direction={{ xs: "column", md: "row" }} alignItems="start" spacing={2}>
        <WasteDateRangePicker
          startDate={startDate}
          endDate={endDate}
          onAccept={handleAccept}
          errorMessage={errorMessage}
          showHelperText={false}
        />
      </Stack>
    </SubNavAppBar>
  );
}
